import { atom } from "jotai";

interface InterviewFindings {
    [key:string] : [];
}


const INITIAL_INTERVIEW_FINDINGS_IN_ATOM_VALUE: InterviewFindings = {};


export const interviewFindingsAtom = atom<InterviewFindings>(INITIAL_INTERVIEW_FINDINGS_IN_ATOM_VALUE);


export const setInterviewFindingsAtom = (set: Function, value: InterviewFindings) => {
    set(interviewFindingsAtom, value);
};
